// extracted by mini-css-extract-plugin
export default {"card":"styles_card__Ttowq","item_text":"styles_item_text__ZvETC","item_icon":"styles_item_icon__9qBsV","weight":"styles_weight__EnAYP","item_code":"styles_item_code__dL1Lb"};